import { apiRequestPost } from 'mastodon/api';
import type { ApiStatusJSON } from 'mastodon/api_types/statuses';

export const apiReorderPinnedStatuses = (ids: string[]) =>
  apiRequestPost<ApiStatusJSON[]>('v1/pinned_statuses/reorder', { ids });
